export default __webpack_public_path__ + "static/media/e-sport-2.41445126.png";